<template>
  <div>
    
    <v-card>
      <v-card-title>Search 
        <v-icon small color="primary" class="ml-3" @click="bHive('search-query')" >{{icons.bHive}}</v-icon>
        <v-icon v-if="$route.name !== 'search'" color="primary" class="ml-3" :disabled="!searchText" @click="permaLink">{{icons.link}}</v-icon>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="7" style="border-right: 1px grey solid;">
            <v-row>
              <v-col cols="8">
                <v-text-field autofocus dense outlined hide-details label="Search" v-model="searchText" v-on:keyup.enter="doSearchFromEnter">
                  <v-icon slot="append" color="secondary" v-if="searchText!==''" @click="doSearch">search</v-icon>
                  <v-icon slot="append" color="warning" v-if="searchItems.results!==undefined" @click="clearSearchTextAndItems">close</v-icon>
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-select dense outlined hide-details :items="statuses" v-model="statusSelect" label="Select Status"></v-select>
              </v-col>
            </v-row>
            <template v-if="searchLoading"><Loader /></template>
            <template v-if="!searchLoading&&!searchLoaded">
              <v-row>
                <v-col>
                  <p><b>Recently Viewed</b></p>

                  <v-list-item-group>

                    <template v-for="(recent, recentI) in recentlyViewed">
                      <template v-if="showFilter.indexOf(recent.type)!==-1||showFilter.length===0">
                        <v-list-item :key="recentI" @click="navToPage(recent)" :href="getURL(recent)">
                          <template v-if="recent.type==='accounts'">
                            <v-list-item-avatar color="primary"><v-icon color="white" :style="icons.size">{{ icons.accounts }}</v-icon></v-list-item-avatar>
                          </template>
                          <template v-if="recent.type==='retention-leads'">
                            <v-list-item-avatar color="tertiary"><v-icon color="white" :style="icons.size">{{ icons.retentionLeads }}</v-icon></v-list-item-avatar>
                          </template>
                          <template v-if="recent.type==='voip'">
                            <v-list-item-avatar color="secondary"><v-icon color="white" :style="icons.size">{{ icons[recent.type] }}</v-icon></v-list-item-avatar>
                          </template>
                          <template v-if="recent.type==='telco'">
                            <v-list-item-avatar color="secondary darken-1"><v-icon color="white" :style="icons.size">{{ icons[recent.type] }}</v-icon></v-list-item-avatar>
                          </template>
                          <template v-if="recent.type==='websites'">
                            <v-list-item-avatar color="secondary darken-2"><v-icon color="white" :style="icons.size">{{ icons[recent.type] }}</v-icon></v-list-item-avatar>
                          </template>
                          <v-list-item-content>
                            <v-list-item-title><b>{{recent.id}}</b> - {{recent.name}}</v-list-item-title>
                            <v-list-item-subtitle>Last viewed - {{formatDate(recent.datetime)}}</v-list-item-subtitle>
                          </v-list-item-content>
                          <template v-if="['voip','telco','websites'].indexOf(recent.type)!==-1">
                            <v-list-item-action class="my-0">
                              <div class="d-flex justify-start">
                                <div>{{recent.status}}</div>
                                <div class="ml-4 mt-n5"><LeadLink :leadid="recent.id" /></div>
                              </div>
                            </v-list-item-action>
                          </template>
                        </v-list-item>
                      </template>
                    </template>

                  </v-list-item-group>

                </v-col>
              </v-row>
            </template>
            <template v-if="!searchLoading&&searchLoaded">
              <v-row>
                <v-col>
                  <p><b>{{`${currentCount} Result${(currentCount===1)?'':'s'} found`}}</b></p>

                  <v-list-item-group>

                    <template v-for="(searchItem, searchItemI) in searchItems">
                      <template v-if="showFilter.indexOf(searchItem.type)!==-1||showFilter.length===0">
                        <v-list-item :key="searchItemI" @click="navToPage(searchItem)" :href="getURL(searchItem)">
                          <template v-if="searchItem.type==='accounts'">
                            <v-list-item-avatar color="primary"><v-icon color="white" :style="icons.size">{{ icons.accounts }}</v-icon></v-list-item-avatar>
                          </template>
                          <template v-else-if="searchItem.type==='retention-leads'">
                            <v-list-item-avatar color="secondary"><v-icon color="white" :style="icons.size">{{ icons.retentionLeads }}</v-icon></v-list-item-avatar>
                          </template>
                          <template v-if="searchItem.type==='voip'">
                            <v-list-item-avatar color="secondary"><v-icon color="white" :style="icons.size">{{ icons[searchItem.type] }}</v-icon></v-list-item-avatar>
                          </template>
                          <template v-if="searchItem.type==='telco'">
                            <v-list-item-avatar color="secondary darken-1"><v-icon color="white" :style="icons.size">{{ icons[searchItem.type] }}</v-icon></v-list-item-avatar>
                          </template>
                          <template v-if="searchItem.type==='websites'">
                            <v-list-item-avatar color="secondary darken-2"><v-icon color="white" :style="icons.size">{{ icons[searchItem.type] }}</v-icon></v-list-item-avatar>
                          </template>
                          <v-list-item-content>
                            <v-list-item-title><b>{{searchItem.id}}</b> - {{searchItem.name | searchItemName}}</v-list-item-title>
                          </v-list-item-content>
                          <template v-if="['voip','telco','websites'].indexOf(searchItem.type)!==-1">
                            <div class="d-flex justify-start">
                              <div>{{searchItem.status}}</div>
                              <div class="ml-4 mt-n5"><LeadLink :leadid="searchItem.id" /></div>
                            </div>
                          </template>
                        </v-list-item>
                      </template>
                    </template>

                  </v-list-item-group>

                </v-col>
              </v-row>
            </template>
          </v-col>
          <v-col cols="5">
            <p><b>Filter By</b></p>
            <v-list-item @click="filter.accounts=!filter.accounts">
              <v-list-item-avatar color="primary"><v-icon color="white" :style="icons.size">{{ icons.accounts }}</v-icon></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  Accounts <v-switch v-model="filter.accounts" class="float-right mt-n1" dense hide-details readonly></v-switch>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item @click="filter.voip=!filter.voip">
              <v-list-item-avatar color="secondary"><v-icon color="white" :style="icons.size">{{ icons.voip }}</v-icon></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  VoIP Products <v-switch v-model="filter.voip" class="float-right mt-n1" dense hide-details readonly></v-switch>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item @click="filter.telco=!filter.telco">
              <v-list-item-avatar color="secondary darken-1"><v-icon color="white" :style="icons.size">{{ icons.telco }}</v-icon></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  Telco Products <v-switch v-model="filter.telco" class="float-right mt-n1" dense hide-details readonly></v-switch>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item @click="filter.websites=!filter.websites">
              <v-list-item-avatar color="secondary darken-2"><v-icon color="white" :style="icons.size">{{ icons.websites }}</v-icon></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  Website Products <v-switch v-model="filter.websites" class="float-right mt-n1" dense hide-details readonly></v-switch>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="filter.retentionLeads=!filter.retentionLeads">
              <v-list-item-avatar color="tertiary"><v-icon color="white" :style="icons.size">{{ icons.retentionLeads }}</v-icon></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  Retention Leads <v-switch v-model="filter.retentionLeads" class="float-right mt-n1" dense hide-details readonly></v-switch>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import LeadLink from '@/components/Globals/LeadLink';
  import { mdiAccount,mdiHeadset,mdiRouterWireless,mdiMonitorDashboard,mdiGavel,mdiBeehiveOutline,mdiLink } from '@mdi/js';
  import { mapState,mapActions } from "vuex";
  import Loader from './../Misc/Loader';
  import moment from 'moment';

  export default {
    components: {Loader,LeadLink},
    data() {
      return {
        searchLoaded: false,
        searchLoading: false,
        searchText: '',
        statusSelect: [],
        icons: {
          size: 'font-size:24px;width:24px;height:24px;',
          accounts: mdiAccount,
          voip: mdiHeadset,
          telco: mdiRouterWireless,
          websites: mdiMonitorDashboard,
          retentionLeads: mdiGavel,
          bHive: mdiBeehiveOutline,
          link: mdiLink,
        },
        filter: {accounts:false,voip:false,telco:false,websites:false,retentionLeads:false},
        statuses: ['Warm','Verification','Provisioning','Provisioning Failed','Provisioned','Ready','Cooling Off','Live','Live and Porting','Cancel','Upgrade','Legacy Upgrade','Trial','Trial Expired','For Approval','Pending Cancel','Porting','On Hold: Future Live Date','On Hold: Telecoms','On Hold: Sales Issue','On Hold: Porting Issue','Order Delay','DOA','Lost','Void','Transfer Out','Bad Debt','Blocked Bad Debt ','Pending Cease Bad Debt','Handed Over','Write Off', 'Written Off', 'Fraud', 'On Hold - Sales Follow-up-Leads', 'Transfer Stopped' ].sort()
      }
    },
    mounted () {
      if(this.$route.query.query && this.$route.name === "search") {
        this.searchText = this.$route.query.query;
        this.doSearch();
      }
      this.getRecentlyViewed();
    },
    computed: {
      ...mapState('globals', ['recentlyViewed','searchItems']),
      showFilter(){
        let filter = [];
        if(this.filter.accounts){ filter.push('accounts'); }
        if(this.filter.voip){ filter.push('voip'); }
        if(this.filter.telco){ filter.push('telco'); }
        if(this.filter.websites){ filter.push('websites'); }
        if(this.filter.retentionLeads){ filter.push('retention-leads'); }
        return filter;
      },
      currentCount(){
        let filter = this.showFilter;
        let count = 0;
        this.searchItems.forEach(item => {
          if(filter.indexOf(item.type)!==-1){
            count++;
          }else if(filter.length===0){
            count++;
          }
        });
        return count;
      },
      getURL() {
        return (recent) => {
          let url;
          if(recent.type==='accounts'){
            url = `/accounts/${recent.id}/`;
          }else if(recent.type==='retention-leads'){
            url = `/retention/${recent.id}/`;
          }else{
            url = `/products/${recent.id}/`;
          }
          return url;
        }
      }
    },
    watch: {
      statusSelect(val) {
        if(val!==''){
          // this.searchText = `status :("${val.join('" OR "')}")`; FOR FUTURE USE
          this.searchText = `status:"${val}"`;
          this.doSearch();
        }
      }
    },
    filters: {
      searchItemName: function(val) {
        return (val === null || val === "" || val === undefined)?'New Customer':val;
      }
    },
    methods: {
      ...mapActions('globals', ['getRecentlyViewed','getSearchItems','clearSearchItems']),
      permaLink() {
        this.$router.push({ name: 'search', query: { query: this.searchText } });
      },
      bHive(ext){
        window.open(`https://sites.google.com/bonline.com/bonlinecrmupdates/${ext}`);
      },
      formatDate(date){
        return moment(date).format('YYYY-MM-DD HH:mm');
      },
      clearSearchTextAndItems(){
        this.searchText = '';
        this.clearSearchItems();
      },
      async doSearchFromEnter(){
        this.statusSelect = '';
        await this.doSearch();
      },
      async doSearch() {
        this.searchLoading = true;
        this.searchLoaded = false;

        if(this.$route.name === "search") {
          let { href } = this.$router.resolve({ name: 'search', query: { query: this.searchText } });
          window.history.pushState({}, null, href);
          await this.getSearchItems(this.searchText);
        } else {
          await this.getSearchItems(this.searchText);
        }
        this.searchLoaded = true;
        this.searchLoading = false;
      },
      navToPage(recent) {
        this.clearSearchTextAndItems();
        let url;
        if(recent.type==='accounts'){
          url = `/accounts/${recent.id}/`;
        }else if(recent.type==='retention-leads'){
          url = `/retention/${recent.id}/`;
        }else{
          url = `/products/${recent.id}/`;
        }
        this.$router.replace(url);
        if(recent.type==='accounts'&&this.$route.name==='account'){
          this.$router.go();
        }
      },
    },
  }
</script>

<style lang="scss" scoped></style>
